export default {
  'SupportSubjectDropDown.subject': {
    en: 'Select a Subject',
    fr: 'Sélectionnez un sujet',
  },
};
